import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {ReviewThread} from '@github-ui/diff-lines/review-thread'
import {StaticUnifiedDiffPreview} from '@github-ui/diff-lines/static-unified-diff-preview'
import {getThreadPreviewsLineAndFileKeysFromThread} from '../../../../../page-data/loaders/use-thread-previews'
import {ThreadReplyComposer} from '../../../../toolbar/comments-panel/ThreadReplyComposer'
import type {ThreadGroupVariant} from '../util/classify-thread'
import {ThreadFilePath} from './ThreadFilePath'
import styles from './ExpandedThread.module.css'
import {noop} from '@github-ui/noop'

export function ExpandedThread({thread, variant}: {thread: Thread; variant: ThreadGroupVariant}) {
  let diffLinesForPreview = thread.subject?.diffLines

  // if we don't have a start line, or it is the same as the end line, then we only want to show the diff line
  // the comment was made on.
  if (!thread.subject?.startLine || thread.subject?.startLine === thread.subject?.endLine) {
    diffLinesForPreview = thread.subject?.diffLines?.slice(-1)
  }

  const {filePath, lineKey} = getThreadPreviewsLineAndFileKeysFromThread(thread)

  return (
    <div className={styles.conversation}>
      <ThreadFilePath thread={thread} variant={variant} />
      <StaticUnifiedDiffPreview className="m-0 border-0" diffLines={diffLinesForPreview} tabSize={4} />
      <ReviewThread
        lineMarkersKey={lineKey ?? ''}
        commentAnchorPrefix={'panel-r'}
        disableSuggestedChangesActions
        filePath={filePath ?? ''}
        isInlineComment={false}
        thread={thread}
        shouldLimitHeight={false}
        repliesDisabled
      />
      {thread.viewerCanReply ? (
        <ThreadReplyComposer
          thread={thread}
          batchingEnabled={false}
          startExpanded={false}
          onCompleted={noop}
          className={styles.threadReplyComposer}
        />
      ) : (
        <div className={styles.threadReplySpacer} />
      )}
    </div>
  )
}
